import { InventoryDocumentItem } from 'models';
import { PurchaseOrderStatusCode, StatusForCardStyles, statusLabels } from 'types';

export const isDateBeforeToday = (date: string | Date | null): boolean => {
  if (!date) return false;

  const deliveryDate = new Date(date);
  const today = new Date();

  // Reset time parts for accurate date comparison
  deliveryDate.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  return deliveryDate < today;
};

// Map status for styling
export const mapStatusForCardStyles = (
  status: PurchaseOrderStatusCode,
  deliveryDate: string | Date,
): StatusForCardStyles => {
  const isDelayed =
    (status === PurchaseOrderStatusCode.READY || status === PurchaseOrderStatusCode.INPROGRESS) &&
    isDateBeforeToday(deliveryDate);

  if (isDelayed) {
    return 'DELAYED';
  }

  switch (status) {
    case PurchaseOrderStatusCode.RECEIVED:
      return 'RECEIVED';
    case PurchaseOrderStatusCode.READY:
      return 'READY';
    case PurchaseOrderStatusCode.INPROGRESS:
      return 'INPROGRESS';
    case PurchaseOrderStatusCode.CANCELLED:
      return 'CANCELLED';
    default:
      return 'READY';
  }
};
export const isExpired = (status: PurchaseOrderStatusCode, deliveryDate: string | Date | null): boolean => {
  return (
    (status === PurchaseOrderStatusCode.READY || status === PurchaseOrderStatusCode.INPROGRESS) &&
    isDateBeforeToday(deliveryDate)
  );
};

// Map status text for display
export const getStatusDisplay = (status: PurchaseOrderStatusCode, deliveryDate: string | Date): string => {
  const isDelayed = isExpired(status, deliveryDate);

  if (isDelayed) {
    return 'Trễ hạn nhập hàng';
  }

  if (status === PurchaseOrderStatusCode.CANCELLED) {
    return 'Phiếu nhập đã hủy';
  }

  return statusLabels[status] || 'Chưa xác định';
};
export const haveActualQuantity = (inventoryItems: InventoryDocumentItem[]): boolean => {
  return inventoryItems.some((item) => item?.actualQuantity && item?.actualQuantity > 0);
};
